export enum CheckoutField {

    billingContact = "billingContact",
    deliveryContact = "deliveryContact",
    firstName = "firstName",
    lastName = "lastName",
    email = "emailAddress",
    phone = "phoneNumber",
    address = "address",
    streetAddress = "streetAddress",
    streetAddress2 = "streetAddress2",
    city = "city",
    zipCode = "zipCode",
    country = "country",
    company = "company",
    name = "name",
    code = "code",
    vatCode = "vatCode",
    sameContact = "sameContact",
    type = "type",
    id = "id",
    kenitala = "identificationNumber",
    companyName = "company",
    legalPerson = "legalPerson",
    latitude = "latitude",
    longitude = "longitude",
    addressAutocomplete = 'addressAutocomplete',
    invoiceRequested = 'invoiceRequested',
    additionalDetails = 'additionalDetails',
    main = 'main',
    contacts = 'contacts',
    customFields = 'customFields',
    defaultShippingAddress = 'defaultShippingAddress',
    defaultBillingAddress = 'defaultBillingAddress'
}